import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { ServicePicker } from "./ServicePicker";
import { DEFAULT_SERVICE } from "@/lib/business";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { name: "", phone: "", services: [DEFAULT_SERVICE], message: "" };
const inputCls = "mt-2 w-full bg-transparent border-b border-white/50 py-2 text-base normal-case tracking-normal font-normal text-paper outline-none focus:border-plate-light transition-colors";

export const InquiryForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [sending, setSending] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.services.length === 0) return toast.error("Bitte mindestens eine Leistung wählen.");
    setSending(true);
    try {
      await axios.post(`${API}/inquiries`, { ...form, message: form.message || null });
      toast.success("Danke! Ich melde mich schnellstmöglich bei Ihnen.");
      setForm(EMPTY);
    } catch {
      toast.error("Senden fehlgeschlagen. Bitte prüfen Sie Name und Telefonnummer.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} className="grid gap-4" data-testid="inquiry-form">
      <label className="lb text-steel">Name
        <input required minLength={2} value={form.name} onChange={set("name")} className={inputCls} data-testid="inquiry-name-input" />
      </label>
      <label className="lb text-steel">Telefon
        <input required minLength={5} type="tel" value={form.phone} onChange={set("phone")} className={inputCls} data-testid="inquiry-phone-input" />
      </label>
      <div className="lb text-steel">Leistungen (mehrere möglich)
        <ServicePicker dark value={form.services} onChange={(v) => setForm({ ...form, services: v })} testId="inquiry-service-picker" />
      </div>
      <label className="lb text-steel">Nachricht (optional)
        <textarea rows={2} value={form.message} onChange={set("message")} className={inputCls} data-testid="inquiry-message-input" />
      </label>
      <button type="submit" disabled={sending} className="lb bg-plate text-white px-6 py-4 mt-2 sm:mt-4 rounded-full sm:rounded-none transition-colors hover:bg-plate-hover disabled:opacity-60" data-testid="inquiry-submit-btn">
        {sending ? "Wird gesendet …" : "Anfrage senden"}
      </button>
      <p className="text-xs text-steel">Mit dem Absenden werden Ihre Angaben zur Bearbeitung der Anfrage verwendet. Mehr in der <Link to="/datenschutz" className="underline hover:text-white" data-testid="inquiry-privacy-link">Datenschutzerklärung</Link>.</p>
    </form>
  );
};
